import { render } from "./VipCenter.vue?vue&type=template&id=c661b6aa&scoped=true"
import script from "./VipCenter.vue?vue&type=script&lang=js"
export * from "./VipCenter.vue?vue&type=script&lang=js"

import "./VipCenter.vue?vue&type=style&index=0&id=c661b6aa&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c661b6aa"]])

export default __exports__